import React, { Component } from 'react'
import { Link, withRouter, Redirect } from 'react-router-dom'
import axios from 'axios'
import Pagination from "react-js-pagination";
import { getUser } from '../../../../actions/session';
import { ACCOUNT_TAB_STIR_SHAKEN, LOGIN_URL, ALL_ACCOUNT_LIST } from '../../../../config/rest_endpoints';
import CustomLoader from '../../../common/loader';
import CustomModal from '../../../common/modal';
import { Notifications } from '../../../common/notification';
import { ADDITIONAL_ACCOUNT_INFO, RC_LOAD_LOGIN, USER_URL } from '../../../routers/RouteConstants';
import CarrierAddSubjectBlock from './components/carrierAddSubjectBlock';
import CarrierUpdateSubjectBlock from './components/carrierUpdateSubjectBlock';


export class CarrierStirShakenSubjectBlock extends Component {
    constructor(props) {
        super(props);
        this.state = {
            User: getUser(),
            isGetting: false,
            accountTable: [],
            accountID: '',
            message: '',
            isAddModal: false,
            isEditModal: false,
            searchValue: '',
            editData: [],
            updateMsg: '',
            activePage: 1,
            itemsCount: 10,
            isDelModal: false,
            delIp: null,
            delSubject: null,
            totalCount: null,
            isExpire: false,
            tableData:[],
            isLoginURL:false,
            isRedirect:false,
            loginData:{},
            isRedirectLoader:false,
            accounts: [] // <-- add accounts to state
        }
        this.accountListing = this.accountListing.bind(this)
        this.openAddModal = this.openAddModal.bind(this)
        this.closeAddModal = this.closeAddModal.bind(this)
        this.closeEditModal = this.closeEditModal.bind(this)
        this.openEditModal = this.openEditModal.bind(this)
        this.deleteServer = this.deleteServer.bind(this);
         this.delcloseModal = this.delcloseModal.bind(this)
        this.delopenModal = this.delopenModal.bind(this)
        this.searchSpace = this.searchSpace.bind(this)
        this.goLoginPage = this.goLoginPage.bind(this)
        this.redirectToUserSide = this.redirectToUserSide.bind(this)
    }

    componentDidMount() {
    const accountID = this.props.match.params.id;
    this.setState({ accountID }, () => {
        this.accountListing(); // ✅ Call only after accountID is set
    });
    // Fetch accounts
    const { User } = this.state;
    const headers = { Authorization: "Bearer " + User.token };
    axios.get(ALL_ACCOUNT_LIST, { headers }).then(res => {
        if (res.data && res.data.data) {
            const accountsData = res.data.data;
            this.setState({ accounts: accountsData });
        }
    });
}


    delcloseModal() {
        this.setState({ isDelModal: false })
    }

    delopenModal(ip) {
        this.setState({
            isDelModal: true,
            delIp: ip.id,
            delSubject: ip.stirShakenSubject
        })
        console.log('ip :>> ', ip);
    }

    closeAddModal() {
        this.setState({
            isAddModal: false
        })
    }

    openAddModal() {
        this.setState({
            isAddModal: true
        })
    }

    openEditModal(row) {
        console.log('row', row)
        this.setState({
            isEditModal: true,
            editData: row
        })
    }

    closeEditModal() {
        this.setState({
            isEditModal: false
        })
    }

    searchSpace(e) {
        this.setState({ searchValue: e.target.value })
    }

    handlePageChange(pageNumber) {
        console.log("Page changed to:", pageNumber);
        this.setState({
            activePage: pageNumber
        }, () => {
            this.accountListing()
        });
    }

    accountListing() {
        const { User, itemsCount, activePage, accountID } = this.state
        this.setState({
            isGetting: true
        })
        var headers = { "Authorization": "Bearer " + User.token };
        const start = Date.now();
        axios.get(`${ACCOUNT_TAB_STIR_SHAKEN}?accountID=${accountID}&page=${activePage}&limit=${itemsCount}`, { headers }).then(res => {
            const minDuration = 1200; // 1.2 seconds
            const elapsed = Date.now() - start;
            const wait = Math.max(0, minDuration - elapsed);
            if (res) {
                var resp = res.data
                setTimeout(() => {
                    this.setState({
                        accountTable: resp.data,
                        message: resp.message,
                        isGetting: false,
                        totalCount: resp.pageinfo.totalCount,
                        activePage: resp.pageinfo.page // Update activePage from response
                    })
                }, wait);
            }
            else {
                setTimeout(() => {
                    this.setState({
                        isGetting: true
                    })
                    Notifications.notify("Fetch failed", "error", "errors");
                }, wait);
            }
        }).catch(err => {
            const alert = err.response
            const minDuration = 1200;
            const elapsed = Date.now() - start;
            const wait = Math.max(0, minDuration - elapsed);
            setTimeout(() => {
                console.log(`Error:`, alert.data.message)
                if (alert.data.message === 'invalid or expired jwt') {
                    localStorage.removeItem('user');
                    this.setState({isLoginURL:true})
                    Notifications.notify(alert.data.message, "Token Expire", "error")
                }
                Notifications.notify(alert.data.message, "Failed", "error")
                this.setState({
                    isGetting: false
                })
            }, wait);
        })
    }

    goLoginPage() {
        this.props.history.push(RC_LOAD_LOGIN)
    }

    redirectToUserSide(data) {
        this.setState({loginData:data, isRedirect:true,isRedirectLoader:true},()=>{
           if(this.state.isRedirect) {
               this.checkToRouteUser()
           }
        })
        setTimeout(() => {
            this.setState({isRedirectLoader:false})
        },2000)
    }

    checkToRouteUser() {
        const {User} = this.state
        console.log(`isRedirect`, this.state.isRedirect)
        window.open(`${USER_URL}/user/${this.props.userId}/token/${User.token}`, '_blank', 'noopener,noreferrer')
    }

    onRedirecting(id,accountName,type) {
        console.log('id', type)
        this.props.history.push(`${ADDITIONAL_ACCOUNT_INFO}/${id}/${accountName}/${type}`)
    }

    __renderAccountTable() {
        const { accountTable, searchValue, accounts } = this.state;
        var nullData = (
            <div className="ml-4 mt-2">
                <div className="dataTables_info" id="DataTables_Table_0_info" role="status" aria-live="polite">Showing 0 of 0 entries</div>
                <div className="dataTables_paginate paging_simple_numbers" id="DataTables_Table_0_paginate"></div>
            </div>
        )
        if (accountTable == null) {
            return nullData
        }
        else {
            return accountTable.filter(table => {
                if (searchValue == null) {
                    return table
                }
                else if (table.stirShakenSubject.toLowerCase().includes(searchValue.toLowerCase())) {
                    return table
                }
            }).map((row, idx) => {
                return (
                    <tr key={idx}>
                        <td style={{textAlign:'center'}}>{row.stirShakenSubject}</td>
                        <td style={{textAlign:'center'}}>{row.note}</td>
                        <td style={{textAlign:'center'}}>{row.createDate}</td>
                        <td style={{textAlign:'center'}}>{row.updateDate}</td>
                        <td style={{textAlign:'center'}}>
                            {(() => {
                                const maxToShow = 3;
                                const names = row.blockedAccounts || [];
                                const showNames = names.slice(0, maxToShow).join(', ');
                                const moreCount = names.length - maxToShow;
                                if (accounts.length > 0 && names.length === accounts.length) {
                                    return 'All';
                                } else if (moreCount > 0) {
                                    return (
                                        <span title={names.join(', ')}>
                                            {showNames} and {moreCount} more
                                        </span>
                                    );
                                } else {
                                    return (
                                        <span title={names.join(', ')}>
                                            {showNames}
                                        </span>
                                    );
                                }
                            })()}
                        </td>
                       <td style={{ textAlign: 'center' }}>
                            {/* <i
                                className="edit-button fa fa-edit mr-3"
                                style={{ cursor: 'pointer' }}
                                onClick={() => this.openEditModal(row)}
                            ></i> */}
                            <i
                                className="edit-button fa fa-trash text-danger"
                                style={{ cursor: 'pointer' }}
                                onClick={() => this.delopenModal(row)}
                            ></i>
                        </td>

                    </tr>
                )
            })
        }

    }

    deleteServer() {
        const { User, delIp } = this.state
        console.log('delIp :>> ', delIp);
        var headers = { "Authorization": "Bearer " + User.token };
        this.setState({isDelLoad:true})
        axios.delete(`${ACCOUNT_TAB_STIR_SHAKEN}/${delIp}`, { headers }).then(res => {
            if (res) {
                this.setState({
                    msg: res.data.message,
                    isDelLoad:false
                })
                this.delcloseModal()
                this.accountListing()
                Notifications.notify(this.state.msg, "Success", "success")
            }
        }).catch(err => {
            const alert = err.response
            console.log(`alert.data.message`, alert.data.message)
            if (alert.data.message === 'invalid or expired jwt') {
                localStorage.removeItem('user');
                this.props.history.push(LOGIN_URL)
                Notifications.notify(alert.data.message, "Token Expire", "error")
            }
            Notifications.notify(alert.data.message, "Failed", "error")
            this.setState({
                isGetting: false
            })
        })
    }

    render() {
        const { isGetting, isAddModal, isEditModal, editData, itemsCount, totalCount, isExpire,User, accountID, isDelModal } = this.state
        console.log("editData", editData)
    
        let addSubjectBlockModal = {
            details: {
                info: "Add Subject Block",
                msg: <CarrierAddSubjectBlock close={this.closeAddModal} accountID={accountID} listingServer={this.accountListing} />
            },
            confirmBtn: { label: "Update", action: '' },
            crossBtn: { action: this.closeAddModal },
            cancelBtn: { label: "Cancel", action: this.closeAddModal }
        }
        let editSubjectBlockModal = {
            details: {
                info: "Edit Subject Block",
                msg: <CarrierUpdateSubjectBlock close={this.closeEditModal} previousData={editData} accountID={accountID} classListing={this.accountListing} />
            },
            confirmBtn: { label: "Update", action: '' },
            crossBtn: { action: this.closeEditModal },
            cancelBtn: { label: "Cancel", action: this.closeEditModal }
        }
        var delModal = (
            <div>
                <div class="modal-body">
                    <h4>Are you sure want to delete <span style={{fontWeight: 'bold'}}>{this.state.delSubject}</span> ? </h4>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-light" onClick={this.delcloseModal} data-dismiss="modal">Close</button>
                    <button  type="button" class="btn btn-danger" onClick={this.deleteServer} disabled={this.state.isDelLoad ? true : false} > Delete  {this.state.isDelLoad ? <i class="fas fa-spinner fa-spin ml-1"></i> : <i className="fa fa-trash ml-1"></i>}</button>
                </div>
            </div>
        )
        let delServerModal = {
            details: {
                info: "Delete Subject Block",
                msg: delModal
            },
            confirmBtn: { label: "Update", action: '' },
            crossBtn: { action: this.delcloseModal },
            cancelBtn: { label: "Cancel", action: this.delcloseModal }
        }
        if(this.state.isLoginURL === true) {
            return <Redirect to={LOGIN_URL} ></Redirect>
        }

      

        return (
            <div>
                <CustomModal
                    visibility={isDelModal}
                    customBodyCSS={"h20"}
                    modalType={"danger"}
                    modalHeader={"danger"}
                    details={delServerModal.details}
                    showBtns={false}
                    cancelBtn={delServerModal.cancelBtn}
                    crossBtn={delServerModal.crossBtn}
                />
                <CustomModal
                    visibility={isAddModal}
                    customBodyCSS={"h20"}
                    modalType={"success"}
                    details={addSubjectBlockModal.details}
                    modalSize={"large"}
                    showBtns={false}
                    cancelBtn={addSubjectBlockModal.cancelBtn}
                    crossBtn={addSubjectBlockModal.crossBtn}
                />
                <CustomModal
                    visibility={isEditModal}
                    customBodyCSS={"h20"}
                    modalType={"success"}
                    modalSize={"large"}
                    details={editSubjectBlockModal.details}
                    showBtns={false}
                    cancelBtn={editSubjectBlockModal.cancelBtn}
                    crossBtn={editSubjectBlockModal.crossBtn}
                />
                <div style={{border:'none',borderRadius:'5px',boxShadow:'0 0 20px rgba(0,0,0,.08)'}} className="card card-body border-left-dark-alpha border-right-dark-alpha ">
                    {/* <div className="card-header header-elements-inline">
                        <div className="header-elements">
                            <button type="submit" className="btn btn-light ml-3" onClick={this.openAddModal}>Login Account <i className="fas fa-plus ml-2"></i></button>
                        </div>
                    </div> */}
                    <div id="DataTables_Table_0_wrapper" className="dataTables_wrapper no-footer mt-2">
                        <div  className="datatable-header">
                            <div id="DataTables_Table_0_filter" className="dataTables_filter">
                                {/* <label className="fs-16"><span>Search :</span>
                                    <input type="search" className="" placeholder="Type to filter..." value={this.state.searchValue} onChange={this.searchSpace} aria-controls="DataTables_Table_0" />
                                </label> */}
                                <div class="input-group">
                                    <input type="text" class="form-control border-right-0" value={this.state.searchValue} onChange={this.searchSpace} placeholder="Filter Subject Block" />

                                    <span class="input-group-append">
                                        <button class="btn search-button" type="button"><i class="fa fa-search"></i></button>
                                    </span>
                                </div>
                            </div>
                            <div className="header-elements">
                            <button type="submit" className="main-button btn btn-primary btn-sm ml-3 float-right" disabled={this.state.isRedirectLoader ? true : false} onClick={this.openAddModal}>Add Subject Block <i className={this.state.isRedirectLoader ? "icon-spinner4 spinner ml-1":"icon-toggle ml-1"}></i></button>
                        </div>
                        </div>
                        <div className="datatable-scroll " style={{overflowX: 'auto' }}>
                            <table  style={{border:'1px solid #ddd',borderTop:'0px solid #ddd',borderCollapse:'collapse'}} className="table table-striped no-footer" id="DataTables_Table_0" role="grid" aria-describedby="DataTables_Table_0_info">
                                <thead>
                                    <tr className="stickeyHeader">
                                        <th style={{color:'black',borderBottom:'2px solid #dee2e6',fontSize:'16px',textAlign:'center'}}>Stir Shaken Subject</th>
                                        <th style={{color:'black',borderBottom:'2px solid #dee2e6',fontSize:'16px',textAlign:'center'}}>Note</th>
                                        <th style={{color:'black',borderBottom:'2px solid #dee2e6',fontSize:'16px',textAlign:'center'}}>Create At</th>
                                        <th style={{color:'black',borderBottom:'2px solid #dee2e6',fontSize:'16px',textAlign:'center'}}>Updated At</th>
                                        <th style={{color:'black',borderBottom:'2px solid #dee2e6',fontSize:'16px',textAlign:'center'}}>Blocked Accounts</th>
                                        <th style={{color:'black',borderBottom:'2px solid #dee2e6',fontSize:'16px',textAlign:'center'}}>Actions</th>
                                    </tr>
                                
                                </thead>
                                <tbody>
                                    {isGetting ? <CustomLoader /> : this.__renderAccountTable()}

                                </tbody>
                            </table>
                        </div>
                        <div className="datatable-footer mt-1">
                            {totalCount >= 9 ? (
                                <div className="mt-3">
                                    <Pagination
                                        activePage={this.state.activePage}
                                        itemsCountPerPage={itemsCount}
                                        totalItemsCount={totalCount}
                                        pageRangeDisplayed={5}
                                        onChange={this.handlePageChange.bind(this)}
                                    />
                                </div>
                            ) : ''}
                            <div className="dataTables_paginate paging_simple_numbers" id="DataTables_Table_0_paginate"></div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default withRouter(CarrierStirShakenSubjectBlock)
